import React, { useState, useContext, } from "react";
import { Box, Button, TextField, Typography, IconButton, Grid, Select, MenuItem } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { createOrder, OneClickTrading, } from "../../../api/request/dashboard/dashboard";
import { ThemeContext } from "../../../context/ThemeContext";
import { setOrderResponse } from "../../../store/Slices/symbolSlice";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
// import { useSymbolPrices } from "../../../context/WebSocketContext";
import AskValue from "../../global/BidAsk/AskValue";
import BidValue from "../../global/BidAsk/BidValue";
import BuyLimit from "./components/BuyLimit";
import SellLimit from './components/SellLimit'
import BuyStop from './components/BuyStop'
import SellStop from './components/SellStop'

const TradeModal = ({ closeModal, onClose, showCloseButton = true }) => {
  const { t } = useTranslation()
  const [stopLoss, setStopLoss] = useState(null);
  const [takeProfit, setTakeProfit] = useState(null);
  const [amount, setAmount] = useState(100);
  const [comment, setComment] = useState("");
  const [orderType, setOrderType] = useState("instantExecution");
  const [disablePlaceorder, setDisablePlaceorder] = useState(true)
  const { darkMode } = useContext(ThemeContext)
  const { globalSymbol, globalSymbolID } = useSelector(state => state.globalSymbol)
  // const symbolId = globalSymbolID || globalSymbol.id;

  const urlParams = new URLSearchParams(window.location.search);
  const querySymbolId = urlParams.get("symbolId");
  const symbolId = querySymbolId || globalSymbolID || globalSymbol.id;

  const { accountId: accountID } = useSelector(state => state.accountSummary)
  const dispatch = useDispatch();
  const [isUserAdjusted, setIsUserAdjusted] = useState({ stopLoss: false, takeProfit: false, });
  const { symbols } = useSelector(state => state.watchlist)
  const symbolData = symbols[symbolId] || {};
  const allSymbolParams = useSelector((state) => state.symbol.allSymbolParams);
  const symbolParameterData = allSymbolParams?.[symbolId] || null;
  // console.log(symbolParameterData);

  const [price, setPrice] = useState(null);
  const [volume, setVolume] = useState(symbolParameterData?.minimumAmountPerDeal);
  const decimalPlaces = useSelector((state) => state.user.decimalPlacesForAmountFormatting);


  const handleVolumeChange = (change) => {
    setVolume((prevVolume) => {
      if (!symbolParameterData) return prevVolume; // Ensure data is available

      const { minimumAmountPerDeal, maximumAmountPerDeal } = symbolParameterData;
      let newVolume = prevVolume + change;
      newVolume = Math.round(newVolume / minimumAmountPerDeal) * minimumAmountPerDeal;

      // Ensure volume is within allowed range
      if (newVolume < minimumAmountPerDeal) newVolume = minimumAmountPerDeal;
      if (newVolume > maximumAmountPerDeal) newVolume = maximumAmountPerDeal;

      return newVolume;
    });
    setAmount(volume * 100)
  };

  // const formatPrice = (price, digits) => {
  //   return price ? price?.toFixed(digits) : "";
  // };

  const handleStopLossChange = (isIncrease) => {
    setStopLoss((prev) => {
      if (prev === null && isIncrease) {
        return parseFloat(symbolData?.bid.toFixed(symbolData?.digits));
      }

      const step = 1 / Math.pow(10, symbolData?.digits || 2);
      let newStopLoss = Math.max(0, prev + (isIncrease ? step : -step));

      newStopLoss = parseFloat(newStopLoss.toFixed(symbolData.digits));

      setIsUserAdjusted((prevState) => ({ ...prevState, stopLoss: true }));
      return newStopLoss;
    });
  };


  const handleTakeProfitChange = (isIncrease) => {
    setTakeProfit((prev) => {
      if (prev === null && isIncrease) {
        return parseFloat(symbolData?.ask.toFixed(symbolData?.digits));
      }

      const step = 1 / Math.pow(10, symbolData?.digits || 2);
      let newTakeProfit = Math.max(0, prev + (isIncrease ? step : -step));

      newTakeProfit = parseFloat(newTakeProfit.toFixed(symbolData.digits));

      setIsUserAdjusted((prevState) => ({ ...prevState, takeProfit: true }));
      return newTakeProfit;
    });
  };


  const handleBuy = async () => {
    if (!accountID) {
      toast.error("Account ID not available.");
      return;
    }
    if (amount <= 0) {
      toast.error("Invalid amount");
      return;
    }
    try {
      const orderPayload = {
        accountId: Number(accountID),
        symbolId: symbolId,
        amount: volume,
        side: 1,
        comment: comment || "Order Trigger",
      };
      const response = await OneClickTrading(orderPayload);
      if (response?.status === 200) {
        dispatch(setOrderResponse(response.data)); // Dispatch the response to the Redux store
        // toast.success("Order placed successfully!")
        toast.success(` Order placed: ID #${response.data.id} , ${symbolData.name} at ${response.data.openPrice} Buy, Amount: ${orderPayload.amount}`);

        // dispatch(fetchAllOrders());
        handleClose();
      } else {
        console.error("Order failed:", response);
        toast.error(response)
      }
    } catch (error) {
      console.error("Error placing order:", error);
      const errorMessage = error?.response?.data?.message || error.message || "Failed to place order.";
      toast.error(errorMessage);
    }
  };

  const handleSell = async () => {
    if (!accountID) {
      toast.error("Account ID not available.");
      return;
    }
    if (amount <= 0) {
      toast.error("Invalid amount");
      return;
    }

    const orderPayload = {
      accountId: Number(accountID),
      symbolId: symbolId,
      amount: volume,
      side: -1,
      comment: comment || "Order Trigger",

    };

    try {
      const response = await OneClickTrading(orderPayload);

      if (response?.status === 200) {
        dispatch(setOrderResponse(response.data));

        toast.success(` Order placed: ID #${response.data.id} , ${symbolData.name} at ${response.data.openPrice} Sell, Amount: ${orderPayload.amount}`);

        console.log("Order placed successfully:", response);
        // toast.success("Sell Order placed successfully!");
        // dispatch(fetchAllOrders());
        handleClose();
      } else {
        toast.error(response)
      }
    } catch (error) {
      console.error("Error placing sell order:", error);
      const errorMessage = error?.response?.data?.message || error.message || "Failed to place order.";
      toast.error(errorMessage);
    }
  };

  const handleClose = () => {
    onClose();
  };
  const handleOrderTypeChange = (event) => {
    setOrderType(event.target.value);
    setPrice("");
  };

  const handlePriceChange = (isIncrease) => {
    setPrice((prev) => {
      let currentPrice = parseFloat(prev);
      if (isNaN(currentPrice)) {
        currentPrice = symbolData?.ask ?? 0;
      }

      const step = 1 / Math.pow(10, symbolData?.digits || 2);
      const priceChange = isIncrease ? step : -step;
      const newPrice = Math.max(0, currentPrice + priceChange);

      return newPrice.toFixed(symbolData?.digits)
    });
  };

  const handlePlaceOrder = async () => {
    if (!accountID) {
      toast.error("Account ID not available.");
      return;
    }
    if (amount <= 0) {
      toast.error("Invalid amount");
      return;
    }

    const stopLossMargin = symbolParameterData?.stopOffset;  // Fixed margin for stop loss
    const takeProfitMargin = symbolParameterData?.stopOffset; // Fixed margin for take profit

    const calculatedStopLoss = symbolData?.high - stopLossMargin; // Sell Stop Loss
    const calculatedTakeProfit = symbolData?.low + takeProfitMargin; // Sell Take Profit
    try {
      const orderPayload = {
        accountId: Number(accountID),
        symbolId: symbolId,
        amount: volume,
        type: Number(orderType),
        price: parseFloat(symbolData?.low),
        stopLoss: parseFloat(calculatedStopLoss),
        takeProfit: parseFloat(calculatedTakeProfit),
        comment: comment || "No Comment",
      };
      // const response = await createOrder(orderPayload);
      const response = await createOrder(orderPayload);
      if (response?.status === 200) {
        dispatch(setOrderResponse(response.data)); // Dispatch the response to the Redux store
        // toast.success("Order placed successfully!")
        toast.success(` Order placed: ID #${response.data.id} , ${symbolData.name} at ${orderPayload.openPrice}, Amount: ${orderPayload.amount}`);

        // dispatch(fetchAllOrders());
        handleClose();
      } else {
        console.error("Order failed:", response);
        toast.error(response)
      }
    } catch (error) {
      console.error("Error placing order:", error);
      const errorMessage = error?.response?.data?.message || error.message || "Failed to place order.";
      toast.error(errorMessage);
    }
  };
  const isInstantExecution = orderType === "instantExecution";

  // const symbol = symbols[symbolData?.id];
  // const ask = symbol?.ask?.toFixed(symbolData?.digits)
  // const bid = symbol?.bid?.toFixed(symbolData?.digits)

  // const calculateSLTP = (orderType) => {
  //   const bid = symbolData?.bid;
  //   const ask = symbolData?.ask;
  //   const digits = symbolData?.digits;
  //   const stopOffset = (symbolParameterData?.stopOffset) / Math.pow(10, digits);

  //   switch (orderType) {
  //     case '1': // Buy Limit
  //     case '2': // Buy Stop
  //       return {
  //         calStopLoss: (bid - stopOffset).toFixed(digits),
  //         calTakeProfit: (bid + stopOffset).toFixed(digits),
  //       };
  //     case '-1': // Sell Limit
  //     case '-2': // Sell Stop
  //       return {
  //         calStopLoss: (ask + stopOffset).toFixed(digits),
  //         calTakeProfit: (ask - stopOffset).toFixed(digits),
  //       };
  //     default:
  //       return { calStopLoss: bid, calTakeProfit: ask };
  //   }
  // };
  // const { calStopLoss, calTakeProfit } = calculateSLTP()


  const handleChangeVolume = (value) => {
    const desimals = value.split('.')?.[1]
    if (!desimals) {
      setVolume(value)
      return;
    }
    if (desimals.length <= decimalPlaces) {
      setVolume(value)
    }
  }

  return (
    <Box sx={{ height: '100%', width: '100%' }}>
      <Grid container spacing={1} sx={{ overflow: 'auto', height: '100%' }}>
        <Grid item xs={12} display={'flex'} justifyContent={'center'}>
          <Box sx={{ width: "100%", bgcolor: darkMode ? "var(--background-color)" : 'var(--white)', fontSize: "0.7rem" }}>
            {/* Modal Header */}
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1, border: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}`, }} >
              <Typography sx={{ p: showCloseButton ? 0 : 1, pl: 1, fontSize: '0.85rem', color: darkMode ? 'var(--lightText)' : "var(--black)", }}>{symbolData?.name}</Typography>
              {showCloseButton && (<IconButton onClick={handleClose} style={{ borderLeft: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}`, borderRadius: 0, color: '#3687ed' }} > <CloseIcon sx={{ fontSize: '1.3rem' }} /> </IconButton>)}
            </Box>

            <Box sx={{ display: "flex", p: 1, flexDirection: 'column' }} >
              <Typography sx={{ fontSize: '0.75rem', color: darkMode ? 'var(--lightText)' : "var(--black)", }}>{t('type')}</Typography>

              <Select value={orderType} onChange={handleOrderTypeChange} sx={{ fontSize: '0.75rem', "&:hover .MuiOutlinedInput-notchedOutline": { border: "none", }, "&.Mui-focused .MuiOutlinedInput-notchedOutline": { border: "none", }, border: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}` }}  >
                <MenuItem value="instantExecution" sx={{ fontSize: '0.75rem' }}>Instant Execution</MenuItem>
                <MenuItem value="1" sx={{ fontSize: '0.75rem' }}>Buy Limit</MenuItem>
                <MenuItem value="-1" sx={{ fontSize: '0.75rem' }}>Sell Limit</MenuItem>
                <MenuItem value="2" sx={{ fontSize: '0.75rem' }}>Buy Stop</MenuItem>
                <MenuItem value="-2" sx={{ fontSize: '0.75rem' }}>Sell Stop</MenuItem>
              </Select>
            </Box>

            <Box sx={{ p: 1, }}>
              <Box sx={{ mb: 2 }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
                  <Typography sx={{ fontSize: '0.75rem', color: darkMode ? 'var(--lightText)' : "var(--black)", }}>{t('amount')}-({t('lot')})</Typography>
                  {/* <Typography variant="caption" align="right" sx={{ fontSize: '0.75rem', color: darkMode ? 'var(--lightText)' : "var(--black)", }}>{(amount)?.toFixed(decimalPlaces)}AUD</Typography> */}
                  <Typography variant="caption" align="right" sx={{ fontSize: '0.7rem', color: darkMode ? 'var(--lightText)' : "var(--black)", }}>{`Min: ${symbolParameterData?.minimumAmountPerDeal}, Max: ${symbolParameterData?.maximumAmountPerDeal}`}</Typography>

                </Box>

                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", border: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}`, overflow: "hidden" }}>
                  <IconButton onClick={() => handleVolumeChange(-symbolParameterData?.minimumAmountPerDeal)}
                    disabled={volume <= symbolParameterData?.minimumAmountPerDeal} sx={{ borderRight: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}`, borderRadius: 0, border: "none" }}>
                    <RemoveIcon fontSize="small" sx={{ fontSize: '1rem', color: darkMode ? 'var(--lightText)' : "var(--black)", }} />
                  </IconButton>
                  <TextField type='number' value={volume} size="small" onChange={(e) => handleChangeVolume(e.target.value)} inputProps={{
                    min: symbolParameterData?.minimumAmountPerDeal,
                    max: symbolParameterData?.maximumAmountPerDeal,
                    step: symbolParameterData?.minimumAmountPerDeal
                    , style: { textAlign: "center", fontSize: '0.9rem' }
                  }} sx={{ width: 120, textAlign: "center", "& .MuiOutlinedInput-notchedOutline": { border: "none" }, color: darkMode ? 'var(--lightText)' : "var(--black)", }} />
                  <IconButton onClick={() => handleVolumeChange(symbolParameterData?.minimumAmountPerDeal)}
                    disabled={volume >= symbolParameterData?.maximumAmountPerDeal} sx={{ borderLeft: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}`, borderRadius: 0, border: "none" }}>
                    <AddIcon fontSize="small" sx={{ fontSize: '1rem', color: darkMode ? 'var(--lightText)' : "var(--black)", }} />
                  </IconButton>
                </Box>
              </Box>
              {orderType == "1" && !isInstantExecution && (<BuyLimit setDisablePlaceorder={setDisablePlaceorder} handlePriceChange={handlePriceChange} price={price} setPrice={setPrice} symbolId={symbolId} stopLoss={stopLoss} setStopLoss={setStopLoss} takeProfit={takeProfit} setTakeProfit={setTakeProfit} handleTakeProfitChange={handleTakeProfitChange} handleStopLossChange={handleStopLossChange} />)}
              {orderType == "-1" && (<SellLimit setDisablePlaceorder={setDisablePlaceorder} handlePriceChange={handlePriceChange} price={price} setPrice={setPrice} symbolId={symbolId} stopLoss={stopLoss} setStopLoss={setStopLoss} takeProfit={takeProfit} setTakeProfit={setTakeProfit} handleTakeProfitChange={handleTakeProfitChange} handleStopLossChange={handleStopLossChange} />)}
              {orderType == "2" && (<BuyStop setDisablePlaceorder={setDisablePlaceorder} handlePriceChange={handlePriceChange} price={price} setPrice={setPrice} symbolId={symbolId} stopLoss={stopLoss} setStopLoss={setStopLoss} takeProfit={takeProfit} setTakeProfit={setTakeProfit} handleTakeProfitChange={handleTakeProfitChange} handleStopLossChange={handleStopLossChange} />)}
              {orderType == "-2" && (<SellStop setDisablePlaceorder={setDisablePlaceorder} handlePriceChange={handlePriceChange} price={price} setPrice={setPrice} symbolId={symbolId} stopLoss={stopLoss} setStopLoss={setStopLoss} takeProfit={takeProfit} setTakeProfit={setTakeProfit} handleTakeProfitChange={handleTakeProfitChange} handleStopLossChange={handleStopLossChange} />)}

              {/* Stop Loss and Take Profit Section */}
              {/* {isInstantExecution ? (
                <>
                  <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2, gap: 2 }}>
                    <Box>

                      <Typography sx={{ fontSize: '0.75rem', color: darkMode ? 'var(--lightText)' : "var(--black)" }}>{t('stopLoss')} :
                        <b style={{ fontSize: '0.7rem' }}>&lt; {isInstantExecution ? (calStopLoss ? calStopLoss.toFixed(symbolData.digits) : "0.00") : (bid ? bid.toFixed(symbolData.digits) : "0.00")}</b>
                      </Typography>
                      <Box sx={{ display: "flex", alignItems: "center", border: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}`, overflow: "hidden", }} >
                        <IconButton onClick={() => handleStopLossChange(false)} sx={{ borderRight: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}`, borderRadius: 0, border: "none", color: darkMode ? 'var(--lightText)' : "var(--black)", }} >
                          <RemoveIcon fontSize="small" sx={{ fontSize: '1rem', color: darkMode ? 'var(--lightText)' : "var(--black)", }} />
                        </IconButton>
                        <TextField type='number' inputProps={{ step: (1 / Math.pow(10, symbolData.digits)), style: { textAlign: "center", fontSize: '0.9rem', padding: 0 } }} value={stopLoss ? parseFloat(stopLoss).toFixed(symbolData.digits) : ''} onChange={(e) => { setStopLoss(e.target.value) }} size="small"
                          sx={{ color: darkMode ? 'var(--lightText)' : "var(--black)", textAlign: "center", "& .MuiOutlinedInput-notchedOutline": { border: "none" }, "& .MuiInputBase-root": { padding: 0 } }} />
                        <IconButton onClick={() => handleStopLossChange(true)} sx={{ borderRight: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}`, borderRadius: 0, border: "none", color: darkMode ? 'var(--lightText)' : "var(--black)", }} >
                          <AddIcon fontSize="small" sx={{ fontSize: '1rem', }} />
                        </IconButton>

                      </Box>
                    </Box>

                    <Box>
                      <Typography sx={{ fontSize: '0.75rem', color: darkMode ? 'var(--lightText)' : "var(--black)" }}>{t('takeProfit')} :
                        <b style={{ fontSize: '0.7rem' }}>&gt; {isInstantExecution ? (calTakeProfit ? calTakeProfit.toFixed(symbolData.digits) : "0.00") : (ask ? ask.toFixed(symbolData.digits) : "0.00")}</b>
                      </Typography>
                      <Box sx={{ display: "flex", alignItems: "center", border: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}`, overflow: "hidden", }}>
                        <IconButton onClick={() => handleTakeProfitChange(false)} sx={{ borderRight: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}`, borderRadius: 0, border: "none", color: darkMode ? 'var(--lightText)' : "var(--black)", }} >
                          <RemoveIcon fontSize="small" sx={{ fontSize: '1rem', }} />
                        </IconButton>
                        <TextField type='number' value={takeProfit ? parseFloat(takeProfit).toFixed(symbolData.digits) : ''} onChange={(e) => { setTakeProfit(e.target.value) }} size="small" inputProps={{ min: 0, step: (1 / Math.pow(10, symbolData.digits)), style: { textAlign: "center", fontSize: '0.9rem', padding: 0 } }}
                          sx={{ textAlign: "center", "& .MuiOutlinedInput-notchedOutline": { border: "none" }, "& .MuiInputBase-root": { padding: 0 }, color: darkMode ? 'var(--lightText)' : "var(--black)", }} />
                        <IconButton onClick={() => handleTakeProfitChange(true)} sx={{ borderRight: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}`, borderRadius: 0, border: "none", color: darkMode ? 'var(--lightText)' : "var(--black)", }}>
                          <AddIcon fontSize="small" sx={{ fontSize: '1rem', }} />
                        </IconButton>
                      </Box>
                    </Box>

                  </Box>
                  <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2, gap: 2 }}>
                    {stopLoss !== null && stopLoss !== undefined && stopLoss >= symbolData?.bid && (
                      <Typography sx={{ fontSize: '0.7rem', color: 'red', mt: 0.5 }}>{t('stopLossshouldbelessthan')} {bid ? bid : '0.00'}</Typography>
                    )}
                    {takeProfit !== null && takeProfit !== undefined && takeProfit <= symbolData?.ask && (
                      <Typography sx={{ fontSize: '0.7rem', color: 'red', mt: 0.5 }}>{t('takeProfitshouldbegreaterthan')} {ask ? ask : '0.00'}</Typography>
                    )}
                  </Box>
                </>
              ) : (null)} */}


              <Box sx={{ mb: 1 }}><Typography sx={{ fontSize: '0.75rem', color: darkMode ? 'var(--lightText)' : "var(--black)", }}>{t('comment')}</Typography>
                <TextField fullWidth size="small" className="custom-textfield " value={comment} onChange={(e) => setComment(e.target.value)} /> </Box>
              {isInstantExecution ? (
                <Box sx={{ display: "flex", justifyContent: 'space-around', m: 1, fontSize: 15, fontWeight: 500 }}>
                  <BidValue symbolId={symbolData?.id} digits={symbolData.digits} />
                  <AskValue symbolId={symbolData?.id} digits={symbolData.digits} />
                </Box>
              ) : (null)}

              {isInstantExecution ? (
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Button variant="contained" fullWidth sx={{ borderRadius: 0, bgcolor: '#da5244' }} onClick={handleSell} > {t('sell')}</Button>
                  <Button variant="contained" className="bg-primary" fullWidth sx={{ borderRadius: 0 }} onClick={handleBuy} > {t('buy')}</Button>
                </Box>
              ) : (
                // Place Order Button (Disabled if price is invalid)
                <Button variant="contained" fullWidth sx={{ borderRadius: 0 }} disabled={disablePlaceorder} onClick={handlePlaceOrder}>{t("placeOrder")}</Button>
              )}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default TradeModal;
